module.exports = __webpack_public_path__ + "img/low-price.71c71f62.png";